import { FEATURE_TAB } from "@/v2-backoffice-client/feature/feature.constants"

/**
 * Operation name of navlayer.query.gql (the Nav layers tab's table);
 * refetched by every mutation that adds a runtime row or flips a field the
 * table shows.
 */
export const NAV_LAYER_QUERY_NAME = "NavLayerQuery"

/** Operation name of view/navlayer.view.query.gql (the open sheet). */
export const NAV_LAYER_VIEW_QUERY_NAME = "NavLayerViewQuery"

/**
 * `id` of the nav layer sheet's tab strip. The tab in view rides in the
 * `<id>-tab` search param (see components/tabs useTabParam), so a link can
 * open the sheet straight on the tab it means.
 */
export const NAV_LAYER_VIEW_TABS_ID = "navlayer-view-tabs"

/** The tab the sheet opens on when the URL says nothing. */
export const NAV_LAYER_VIEW_DEFAULT_TAB = FEATURE_TAB.configuration

/**
 * Feature codes of nav layers all start with this. Nav layers are the one
 * catalog with no table of its own — the prefix is what tells a
 * common.Features row apart from every other feature in the same table.
 */
export const NAV_LAYER_FEATURE_CODE_PREFIX = "NavLayer_"
